module.exports = __webpack_public_path__ + "img/SuccessCircle.e8aab0ff.svg";